import React, { useEffect } from 'react';
export default function ClientTestimonials() {
  useEffect(() => {
    // Remove any existing trustindex script to prevent duplicates
    const existing = document.querySelector('script[src*="trustindex"]');
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
    const container = document.getElementById('trustindex-widget');
    if (!container) return;
    const script = document.createElement('script');
    script.src = 'https://cdn.trustindex.io/loader.js?fdbbc7966ea53365a3362222c15';
    script.async = true;
    script.defer = true;
    container.appendChild(script);
    return () => {
      const el = document.querySelector('script[src*="trustindex"]');
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
  }, []);
  return <section className="pt-12 pb-20 bg-white">
      <div className="container max-w-5xl">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">Client Testimonials</h2>
        <div id="trustindex-widget"></div>
      </div>
    </section>;
}